<div class="attachment-uploading-wrapper">
  <app-progress-bar [value]="attachment.progress" (onCancel)="onCancel()">
  </app-progress-bar>

  <span *ngIf="!attachment.error" class="info">
    {{
      (attachment.progress == 100 ? 'LABEL.UPLOADED' : 'LABEL.UPLOADING')
        | translate: { fileName: attachment.title }
    }}
  </span>

  <div *ngIf="attachment.error" class="error-container">
    <span class="error">
      {{ attachment.error }}
    </span>

    <button (click)="onRetry()" class="try-again">
      {{ 'ACTION.TRY_AGAIN' | translate }}
    </button>
  </div>
</div>
